// extracted by mini-css-extract-plugin
export default {"wrapper":"sharedWith_wrapper__fvNwN","popoverContent":"sharedWith_popoverContent__cpwub"};